import React from 'react';
import { Box } from '../../../grid/Box/styled.js';
import { ToggleButtonGroupContext } from '../context.js';

const Group = ({ onChange, children }) => {
    return (React.createElement(ToggleButtonGroupContext.Provider, { value: React.useMemo(() => ({ onChange }), [onChange]) },
        React.createElement(Box, null, children)));
};
Group.displayName = 'ToggleButton.Group';

export { Group };
//# sourceMappingURL=Group.js.map
